import * as React from "react";

import Slide from "@material-ui/core/Slide/Slide";

const HouseholdTransition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default HouseholdTransition;



// WEBPACK FOOTER //
// ./src/components/Transition/index.jsx